import axios from 'axios';
import qs from 'qs';
import { apiErrorToStr } from '../utils';

class Module {
  constructor(moduleName, api, isMultipart) {
    this.api = api;
    this.moduleName = moduleName;
    this.isMultipart = isMultipart;
    this.actionTypes = {
      GET: `${moduleName}/get`,
      GET_BY_ID: `${moduleName}/getById`,
      SAVE: `${moduleName}/save`,
      DELETE: `${moduleName}/delete`,
      RESET_STATE: `${moduleName}/resetState`,
      RESET_SUCCESS_SAVE: `${moduleName}/resetSuccessSave`,
    };
    this.initialState = {
      isLoading: false,
      successSave: null,
      data: {
        results: [],
        total: 0,
      },
      error: null,
    };
    this.reducer = this.reducer.bind(this);
  }

  // allowed params: fields, filter, page, sort
  get = params => dispatch => dispatch({
    type: this.actionTypes.GET,
    payload: axios.get(this.api, {
      params,
      // eslint-disable-next-line no-shadow
      paramsSerializer: params => qs.stringify(params),
    }),
  });

  getById = id => dispatch => dispatch({
    type: this.actionTypes.GET_BY_ID,
    payload: axios.get(`${this.api}/${id}`),
  });

  save = data => async (dispatch) => {
    const { id } = data;
    let options;

    if (this.isMultipart) {
      const formData = new FormData();

      // eslint-disable-next-line
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          if (data[key] instanceof File) {
            formData.append(key, data[key]);
            delete data[key];
          }
        }
      }

      formData.append('json', JSON.stringify(data));

      data = formData;
      options = { headers: { 'Content-Type': 'multipart/form-data' } };
    }

    const payload = id ? axios.put(`${this.api}/${id}`, data, options) : axios.post(this.api,
      data,
      options);
    dispatch({ type: this.actionTypes.SAVE, payload });
  };

  remove = (id, filter, page) => async (dispatch) => {
    try {
      await axios.delete(`${this.api}/${id}`);
      dispatch(this.get({ filter, page }));
    } catch (e) {
      dispatch({ type: `${this.actionTypes.DELETE}_REJECTED`, payload: e });
    }
  };

  resetState = () => ({ type: this.actionTypes.RESET_STATE });

  resetSuccessSave = () => ({ type: this.actionTypes.RESET_SUCCESS_SAVE });

  reducer(state = this.initialState, { type, payload }) {
    const {
      GET, GET_BY_ID, SAVE, RESET_STATE, RESET_SUCCESS_SAVE,
    } = this.actionTypes;
    const data = payload && payload.data ? payload.data.data : null;
    const pendingRegex = new RegExp(`${this.moduleName}.*pending`, 'gi');
    const rejectedRegex = new RegExp(`${this.moduleName}.*rejected`, 'gi');

    if (pendingRegex.test(type)) {
      return { ...this.initialState, isLoading: true };
    } else if (rejectedRegex.test(type)) {

      const error = apiErrorToStr(payload.response);

      if (payload.response.status == 412) {
        return { ...state, error };
      } else {
        return { ...this.initialState, error };
      }
    }
    switch (type) {
      case `${GET}_FULFILLED`:
      case `${GET_BY_ID}_FULFILLED`:
        return { ...this.initialState, data };

      case `${SAVE}_FULFILLED`:
        return { ...this.initialState, data, successSave: true };

      case RESET_SUCCESS_SAVE:
        return { ...state, successSave: null };

      case RESET_STATE:
        return this.initialState;

      default:
        return state;
    }
  }
}

export default Module;



// WEBPACK FOOTER //
// ./src/modules/Module.js